module.exports = __webpack_public_path__ + "img/ic_zdjg@3x.a820d38b.png";